import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { animationDuration, smallScreenWidth, toastsZIndex } from './consts';
import styled from 'styled-components';
import { hide, putOnHold, release } from './actions';
import { useDispatch } from 'react-redux';
import { Icon } from '../common/icon/Icon';
import { FONT_FAMILY_SECONDARY } from '../styles/typography';
const maxWidth = 500;

const StyledToast = styled.div`
	z-index: ${toastsZIndex};
	margin-top: 0;
	max-width: ${maxWidth}px;
	opacity: 0;
	transition: opacity 0.3s, margin-top 0.3s;
	box-shadow: 0px 4px 30px 6px rgba(32, 56, 87, 0.4);
	border-radius: 30px;
	font-family: ${FONT_FAMILY_SECONDARY};
	padding: 18px 20px;
	position: relative;

	.alert-text {
		margin-left: 32px;
	}
	
	.alert-text-message {
		font-weight: 400;
	}

	.alert-text-message {
		font-size: 14px;
	}

	@media (min-width: ${smallScreenWidth}px) {
		width: ${maxWidth}px;
	}

	&.toast-appear {
		opacity: 0.01;
	}

	&.toast-enter-done,
	&.toast-appear-active {
		opacity: 1;
		margin-top: 10px;
	}

	&.alert {
		margin-bottom: 10px;
	}

	.icon {
		font-size: 20px;
		font-weight: 100;
		width: 20px;
		height: 20px;
		top: 15px;
		left: 20px;
		margin: 0;
		line-height: 20px;
	}
	.alert-close {
		position: absolute;
		right: 20px;
		top: 15px;
		line-height: 20px;
		font-size: 16px;
	}

	&.alert-danger {
		background-color: var(--Red-050, rgba(255, 212, 215, 1));
	}
	&.alert-success {
		background-color: var(--Green-025, rgba(230, 255, 242, 1));
	}
	&.alert-info {
		background-color: var(--Blue-025, rgba(227, 242, 255, 1));
	}
	&.alert-warning {
		background-color: var(--Orange-025, rgba(255, 240, 229, 1));
	}
	
	
`;

const FeatureText = styled.span`
	font-weight: 500;
`;

function Toast({ uuid, messageType, message, headline, visible }) {
	const nodeRef = useRef(null);
	const isError = messageType === 'error';
	const isWarning = messageType === 'warning';
	const isInfo = messageType === 'info';
	const isSuccess = messageType === 'success';

	const className = classNames('toast alert',{
		'alert-danger': isError,
		'alert-success': isSuccess,
		'alert-info': isInfo,
		'alert-warning': isWarning,
	});
	const iconClass = classNames('alert-icon icon',{
		'icon-times-circle': isError || isWarning,
		'icon-circle-check-outline_minor': isSuccess,
		'icon-check': isInfo,
	});
	const dispatch = useDispatch();

	const onClose = useCallback(() => {
		dispatch(hide(uuid));
	},[dispatch, uuid]);

	const onMouseEnter = useCallback(() => {
		dispatch(putOnHold(uuid));
	},[dispatch, uuid]);

	const onMouseLeave = useCallback(() => {
		dispatch(release(uuid));
	},[dispatch, uuid]);

	return (<CSSTransition
		in={visible}
		nodeRef={nodeRef}
		classNames="toast"
		appear
		timeout={animationDuration}
	>
		<StyledToast ref={nodeRef} className={className} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
			<span className={iconClass}></span>
			<div  className="alert-text"><FeatureText>{headline} </FeatureText>
				<span className="alert-text-message">{message || uuid}</span></div>
			<button type="button" className="alert-close" onClick={onClose}><Icon name="x" /></button>
		</StyledToast>
	</CSSTransition>
	);
}

Toast.defaultProps = {
	visible: true
};

Toast.propTypes = {
	uuid: PropTypes.string.isRequired,
	messageType: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	headline: PropTypes.string.isRequired,
	visible: PropTypes.bool,
};

export default React.memo(Toast);
